module.exports = __webpack_public_path__ + "fonts/bhicons.1be4a507.eot";